import { Page } from '../../state';
import { PageActionType } from './page-action-type';
import { RedirectingAction } from '../interfaces';

export interface CreatePageSuccessAction extends RedirectingAction {
  pageKey: string;
  type: PageActionType.CreatePageSuccess;
  page: Partial<Page>;
}

export const createPageSuccess = (
  pageKey: string,
  page: Partial<Page>,
  options: RedirectingAction = {},
): CreatePageSuccessAction => ({
  ...options,
  page,
  pageKey,
  type: PageActionType.CreatePageSuccess,
});
